export const Help = () => {
	return (
		<div className="p-6 grid gap-2">
			<h2>Ayuda</h2>
			<h3>Contactos de soporte</h3>
			<div className="p-4 border border-gray-200 rounded-md">
				<h5>Departamento de Planeamiento Urbano</h5>
				<span>
					Tel.:{" "}
					<a href="tel:+18092422000" className="hover:underline">
						(809) 242-2000
					</a>{" "}
					ext. 120/141
				</span>
				<br />
				<span>
					Correo:{" "}
					<a href="mailto:planeamientourbano@alcaldialavega.gob.do" className="hover:underline">
					planeamientourbano@alcaldialavega.gob.do
					</a>
				</span>
				<br></br>
				<span>
					Correo:{" "}
					<a href="mailto:planeamientourbanolv@gmail.com" className="hover:underline">
					planeamientourbanolv@gmail.com
					</a>
				</span>
			</div>
		</div>
	)
}
